import { Fragment } from "react";
import Enums from "../../utilities/enum";
import { dateRange, toInputFieldDateString } from "../../utilities/dateUtilities";

const presetGroups = [
    [
        { dateRangeType: 0 },
    ],
    [
        { dateUtilityKey: "currentDay", dateRangeType: 1 },
    ],
    [
        { dateUtilityKey: "currentMonth", dateRangeType: 3 },
        { dateUtilityKey: "currentQuarter", dateRangeType: 4 },
        { dateUtilityKey: "currentYear", dateRangeType: 6 },
    ],
    [
        { dateUtilityKey: "lastMonth", dateRangeType: 2 },
        { dateUtilityKey: "lastQuarter", dateRangeType: 5 },
        { dateUtilityKey: "lastYear", dateRangeType: 7 },
    ],
    [
        { dateUtilityKey: "monthToDate", dateRangeType: 9 },
        { dateUtilityKey: "quarterToDate", dateRangeType: 10 },
        { dateUtilityKey: "yearToDate", dateRangeType: 8 },
    ],
]

const presetHelperText = {
    1: "the day it's sent.",
    2: "the whole month before the month it's sent in.",
    3: "the whole month it's sent in, from the 1st to the last day.",
    4: "the whole quarter it's sent in.",
    5: "the whole quarter before the one it's sent in.",
    6: "the whole year it's sent in.",
    7: "the whole year before the one it's sent in.",
    8: "1 January up to the day it's sent.",
    9: "the 1st of the month up to the day it's sent.",
    10: "the first day of the quarter up to the day it's sent.",
}

export const isScheduleDateRangeCustomRangeInvalid = (scheduledDateRangeTypePreset, scheduleFromDate, scheduleToDate) => (
    scheduledDateRangeTypePreset === null
    && (scheduleFromDate === null || scheduleFromDate === "" || scheduleToDate === null || scheduleToDate === "")
)

const PresetOption = ({ dateUtilityKey, dateRangeType, label, isActive, onSelect }) => {
    const resolvedRange = dateUtilityKey ? dateRange(dateUtilityKey) : null
    return (
        <button
            type="button"
            onClick={ () => onSelect(resolvedRange?.firstDate, resolvedRange?.lastDate, dateRangeType) }
            className={ `dropdown-item ${ isActive ? "active" : "" }` }
        >
            <span>{ label }</span>
        </button>
    )
}

// A preset is a rule re-resolved each time the schedule runs, not a fixed window, so once one is
// selected the concrete from/to dates are hidden and only the preset's name is shown.
export const ScheduleExportDateRangePicker = ({
    scheduledDateRangeTypePreset,
    setScheduledDateRangeTypePreset,
    scheduleFromDate,
    setScheduleFromDate,
    scheduleToDate,
    setScheduleToDate,
}) => {
    const isCustomRange = scheduledDateRangeTypePreset === null
    const isCustomRangeInvalid = isScheduleDateRangeCustomRangeInvalid(scheduledDateRangeTypePreset, scheduleFromDate, scheduleToDate)
    const selectedPresetLabel = Enums.DateRangeType[scheduledDateRangeTypePreset]
    const selectedPresetHelperText = presetHelperText[scheduledDateRangeTypePreset]

    return (
        <div className="w-100">
            <div className="d-flex align-items-center w-100">
                <div className="form-group mb-0 d-flex date-range-picker flex-grow-1 date-range-picker--full-width">
                    {
                        isCustomRange
                            ? <>
                                <input
                                    className="form-control form-control-sm text-center"
                                    id="schedule-export-from-date-picker"
                                    type="date"
                                    value={ toInputFieldDateString(scheduleFromDate) }
                                    onClick={ e => e.target.showPicker() }
                                    onChange={ e => setScheduleFromDate(e.target.value) }
                                />
                                <input
                                    className="form-control form-control-sm text-center"
                                    id="schedule-export-to-date-picker"
                                    type="date"
                                    value={ toInputFieldDateString(scheduleToDate) }
                                    onClick={ e => e.target.showPicker() }
                                    onChange={ e => setScheduleToDate(e.target.value) }
                                />
                            </>
                            : <div className="form-control form-control-sm text-center flex-grow-1">{ selectedPresetLabel }</div>
                    }
                    <div className="btn-group date-mega-control schedule-export-date-mega-control">
                        <button className="btn dropdown-toggle m-0" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                        <div className="dropdown-menu dropdown-menu-right">
                            {
                                presetGroups.map(group => (
                                    <Fragment key={ group[0].dateRangeType }>
                                        {
                                            group.map(preset => (
                                                <PresetOption
                                                    isActive={ scheduledDateRangeTypePreset === preset.dateRangeType }
                                                    dateUtilityKey={ preset.dateUtilityKey }
                                                    dateRangeType={ preset.dateRangeType }
                                                    label={ Enums.DateRangeType[preset.dateRangeType] }
                                                    onSelect={ (firstDate, lastDate, dateRangeType) => {
                                                        if (firstDate !== undefined) {
                                                            setScheduleFromDate(firstDate)
                                                            setScheduleToDate(lastDate)
                                                        }
                                                        setScheduledDateRangeTypePreset(dateRangeType)
                                                    } }
                                                    key={ preset.dateRangeType }
                                                />
                                            ))
                                        }
                                    </Fragment>
                                ))
                            }
                            <button
                                type="button"
                                onClick={ () => setScheduledDateRangeTypePreset(null) }
                                className={ `dropdown-item ${ isCustomRange ? "active" : "" }` }
                            >
                                <span>Custom range</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            { selectedPresetHelperText && <p className="text-muted fs--1 m-0 mt-1">Each time it's sent, this report covers { selectedPresetHelperText }</p> }
            { isCustomRangeInvalid && <p className="text-danger fs--1 m-0 mt-1">This field cannot be blank</p> }
        </div>
    )
}
